import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { downloadUrl } from "@/lib/api";
import { EmptyState } from "@/components/ui/bits";
import { fmtDate } from "@/lib/constants";
import { BarChart3, Download } from "lucide-react";

export default function ClientReports() {
  const { user } = useAuth();
  const [reports, setReports] = useState([]);
  useEffect(() => {
    api.get(`/documents?client_id=${user.client_id}&category=report`).then(({ data }) => setReports(data)).catch(() => {});
  }, [user.client_id]);
  return (
    <div>
      <h1 className="font-serif font-bold text-3xl text-white mb-1">Reports</h1>
      <p className="text-slate-400 mb-5">Management accounts and reports shared by your team.</p>
      {reports.length === 0 ? <EmptyState icon={BarChart3} title="No reports yet" hint="Your team will publish reports here." /> : (
        <div className="space-y-2">
          {reports.map((d) => (
            <div key={d.id} className="card-surface rounded-xl p-4 flex items-center justify-between">
              <div className="flex items-center gap-3"><BarChart3 className="text-[#C9A84A]" size={20} /><div><div className="text-white text-sm">{d.original_filename}</div><div className="text-slate-500 text-xs">{fmtDate(d.created_at)}</div></div></div>
              <a href={downloadUrl(`documents/${d.id}/download`)} target="_blank" rel="noreferrer" className="text-slate-400 hover:text-white p-2"><Download size={18} /></a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
